module.exports = require('../abstract').extend
  template: require('./index.pug')

  methods:

    loadConfig: ->
      settings = require('shared/util/site_settings')

      @.$store.dispatch('settings/set', settings)

  created: ->
    @loadConfig()



// WEBPACK FOOTER //
// ./assets/js/shared/components/settings_loader/index.coffee